import { CEProcessRoleBase } from './ce-process-role-base'


export class CEProcessRole extends CEProcessRoleBase {

}